/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import React from 'react';
import PropTypes from 'prop-types';

const MediaCardSkeleton = ({ viewMode = 'comfortable' }) => {
  if (viewMode === 'list') {
    return (
      <tr className="border-b border-base-content/5 animate-pulse">
        <td className="px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="skeleton w-12 h-9 rounded-lg flex-shrink-0" />
            <div className="space-y-1.5 flex-1 min-w-0">
              <div className="skeleton h-3.5 w-48 rounded" />
              <div className="skeleton h-2.5 w-24 rounded" />
            </div>
          </div>
        </td>
        <td className="px-4 py-3">
          <div className="skeleton h-5 w-16 rounded-full" />
        </td>
        <td className="px-4 py-3">
          <div className="skeleton h-3 w-14 rounded" />
        </td>
        <td className="px-4 py-3">
          <div className="skeleton h-3.5 w-24 rounded" />
        </td>
        <td className="px-4 py-3">
          <div className="skeleton h-3 w-28 rounded" />
        </td>
        <td className="px-4 py-3 text-right">
          <div className="flex items-center justify-end gap-1.5">
            <div className="skeleton w-7 h-7 rounded-lg" />
            <div className="skeleton w-7 h-7 rounded-lg" />
          </div>
        </td>
      </tr>
    );
  }

  if (viewMode === 'compact') {
    return (
      <div className="bg-base-100 border border-base-content/5 rounded-xl overflow-hidden shadow-sm animate-pulse">
        <div className="aspect-[4/3] skeleton rounded-none" />
        <div className="p-2 space-y-1.5">
          <div className="skeleton h-3 w-3/4 rounded" />
          <div className="skeleton h-2 w-1/2 rounded" />
        </div>
      </div>
    );
  }

  // Comfortable grid card
  return (
    <div className="bg-base-100 border border-base-content/5 rounded-2xl overflow-hidden shadow-sm animate-pulse">
      <div className="aspect-[16/10] skeleton rounded-none" />
      <div className="p-3.5 space-y-2.5">
        <div className="skeleton h-3.5 w-4/5 rounded" />
        <div className="flex items-center justify-between">
          <div className="skeleton h-2.5 w-1/3 rounded" />
          <div className="skeleton h-2.5 w-1/4 rounded" />
        </div>
        <div className="pt-2 border-t border-base-content/5 flex items-center justify-between">
          <div className="skeleton h-3 w-20 rounded" />
          <div className="skeleton h-2.5 w-16 rounded" />
        </div>
      </div>
    </div>
  );
};

MediaCardSkeleton.propTypes = {
  viewMode: PropTypes.oneOf(['comfortable', 'grid', 'compact', 'list']),
};

export default MediaCardSkeleton;
